import { DeliveryDate, DeliverySlot, DeliveryZone } from '@delivery/const';
import { StateUtils } from '@spartacus/core';

export const DELIVERY_FEATURE = 'delivery';
export const DELIVERY_SLOTS = '[Delivery] Delivery Slots';
export const DELIVERY_ZONES = '[Delivery] Delivery Zones';
export const DELIVERY_DATE = '[Delivery] Delivery Date';

export interface StateWithDelivery {
  [DELIVERY_FEATURE]: DeliveryState;
}

export interface DeliveryState {
  deliverySlots: StateUtils.LoaderState<DeliverySlot[]>;
  deliveryZones: StateUtils.EntityLoaderState<DeliveryZone[]>;
  deliveryDate: StateUtils.LoaderState<DeliveryDate>;
}
